import React from 'react'
import Temp from "./Temp"
import Heading from "./Heading"

import Current from "../charts/Current"
import Hourly from "../charts/Hourly"
import SevenDay from "../charts/SevenDay"

import '../styles/index.scss'
import '../styles/fonts.scss'
import backgroundTheme from "../themes/backgroundTheme"

export default function DataSquare(props) {
    const display = () => {
        if (props.dashboard === "current"){
            return <Current current={props.current}/>
        }
        if (props.dashboard === "hourly"){
            return <Hourly unit={props.unit} timezone={props.timezone} data={props.data}/>
        }
        if (props.dashboard === "seven-day"){
            return <SevenDay unit={props.unit} daily={props.daily}/>
        }
    }

    const colorChange = () => {
        let style;
        let hour = new Date().getHours();
        for (const item of backgroundTheme){
            for (const colorHour of item.hour){
                if (hour === colorHour){
                    style = item.btnStyle;
                }
            }
        }
        return style;
    }

    const btnStyle = (e) => {
        if (props.dashboard === e){
            return colorChange();
        }
    }
    const chevStyle = (e) => {
        if (props.dashboard === e){
            return {visibility: "hidden"}
        }
    }

    //edit button style
    //the onClick needs to be triggered on the chevron
    return (
        <div className="data-square">
            <Temp current={props.current} onClick={props.onClick} unit={props.unit}/>
            <Heading location={props.location} date={props.date}/>
            <div className="button-row">
                <button className="btn-tog" id="current" style={btnStyle("current")} onClick={props.onClick2}>Current</button>
                <button className="btn-tog" id="hourly" style={btnStyle("hourly")} onClick={props.onClick2}>Hourly</button>
                <button className="btn-tog" id="seven-day" style={btnStyle("seven-day")} onClick={props.onClick2}>Daily</button>
            </div>

            <div className="data-panel">
                <button className="button-next">
                    <i className="fas fa-chevron-left icon-btn" 
                       id="scroll-left"
                       style={chevStyle("current")} 
                       onClick={props.onClick2}>
                    </i>
                </button>
                   {display()}
                <button className="button-next">
                    <i className="fas fa-chevron-right icon-btn"
                       id="scroll-right"
                       style={chevStyle("seven-day")}
                       onClick={props.onClick2}> 
                    </i>
                </button>
            </div>
            
        </div>
    )
}
